document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".menu-toggle")?.addEventListener("click", () => {
    document.querySelector("#nav-links")?.classList.toggle("is-open");
  });
  const stage = document.getElementById("tryon-frame");
  const picks = document.querySelectorAll(".frame-pick");
  if (!stage || !picks.length) return;
  const shapes = {
    cat: `<svg viewBox="0 0 220 70" fill="none" stroke="currentColor" stroke-width="5"><path d="M18 42c2-18 22-28 48-22 18 4 28 16 32 24"/><path d="M202 42c-2-18-22-28-48-22-18 4-28 16-32 24"/><path d="M98 40h24M10 40h10M200 40h10"/></svg>`,
    aviator: `<svg viewBox="0 0 220 70" fill="none" stroke="currentColor" stroke-width="5"><ellipse cx="58" cy="38" rx="46" ry="24"/><ellipse cx="162" cy="38" rx="46" ry="24"/><path d="M104 34h12"/></svg>`,
    round: `<svg viewBox="0 0 220 70" fill="none" stroke="currentColor" stroke-width="5"><circle cx="58" cy="36" r="26"/><circle cx="162" cy="36" r="26"/><path d="M84 34h52"/></svg>`,
    square: `<svg viewBox="0 0 220 70" fill="none" stroke="currentColor" stroke-width="5"><rect x="16" y="16" width="80" height="42" rx="6"/><rect x="124" y="16" width="80" height="42" rx="6"/><path d="M96 34h28"/></svg>`
  };
  const setShape = (shape) => {
    stage.innerHTML = shapes[shape] || shapes.square;
    picks.forEach((p) => p.classList.toggle("is-active", p.dataset.shape === shape));
  };
  picks.forEach((p) => {
    p.innerHTML = shapes[p.dataset.shape] || "";
    p.addEventListener("click", () => setShape(p.dataset.shape));
  });
  setShape("cat");
});
